import SelfAccountList from '@containers/account/SelfAccountList';

const SelfAccountListPage = () => {
  return <SelfAccountList />;
};

export default SelfAccountListPage;
